import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Bell, Check } from "lucide-react";
import api from "../lib/api";
import { SectionTitle, GhostButton } from "../components/common";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const load = async () => { const { data } = await api.get("/notifications"); setItems(data.notifications); };
  useEffect(() => { load(); }, []);
  const markAll = async () => { await api.post("/notifications/read", {}); load(); };

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-8">
      <div className="flex items-center justify-between mb-6">
        <SectionTitle eyebrow="Stay in the loop" title="Notifications" />
        <GhostButton data-testid="mark-all-read-btn" onClick={markAll} className="text-xs px-4 py-2 flex items-center gap-1.5"><Check size={14} /> Mark all read</GhostButton>
      </div>
      {items.length === 0 ? (
        <div className="text-center py-20 text-[#9E978E]"><Bell size={40} className="mx-auto mb-3 opacity-40" /><p>No notifications yet.</p></div>
      ) : (
        <div className="space-y-2">
          {items.map((n) => (
            <div key={n.notification_id} className={`rounded-xl border p-4 ${n.read ? "border-white/8 bg-[#141113]/40" : "border-[#D4AF37]/30 bg-[#541224]/20"}`}>
              <div className="flex items-start justify-between gap-3">
                <div><h4 className="text-[#FBF8F3] font-medium text-sm">{n.title}</h4><p className="text-sm text-[#9E978E] mt-0.5">{n.body}</p></div>
                {!n.read && <span className="h-2 w-2 rounded-full bg-[#D4AF37] shrink-0 mt-1.5" />}
              </div>
              <div className="text-[11px] text-[#9E978E] mt-2">{new Date(n.created_at).toLocaleString()}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
